import React, { createContext, useContext, useState } from "react";

const translations = {
  vi: {
    slogan: "TỐI ƯU HIỆU SUẤT — KIẾN TẠO GIÁ TRỊ TÁI TẠO",
    email: "needhelp@kipso.com",
    phone: "444 888 0000",
    login: "Đăng nhập",
    register: "Đăng ký",
    home: "TRANG CHỦ",
    technology: "CÔNG NGHỆ & TRÍ TUỆ SỐ",
    technologySolutions: "GIẢI PHÁP CÔNG NGHỆ SỐ",
    technologyEpc: "CHUYỂN ĐỔI SỐ NGÀNH EPC",
    technologyAi: "GIẢI PHÁP AI & TỰ ĐỘNG HÓA",
    epc: "CỐ VẤN QUẢN TRỊ EPC",
    epcPhilosophy: "Triết lý Điều hành",
    epcAssessment: "Thẩm định Doanh nghiệp",
    epcRoadmap: "Lộ trình Cố vấn",
    talent: "ÁNH DƯƠNG TALENT",
    talentMission: "Sứ mệnh Tự cường",
    talentPlatform: "Nền tảng Năng lực Solar",
    talentNetwork: "Mạng lưới Tinh hoa",
    portal: "CỔNG GIAO DỊCH",
    portalAssessment: "Gói Thẩm định Doanh nghiệp",
    portalTalent: "Chương trình Ánh Dương Talent",
    portalTechnology: "Giải pháp Công nghệ số",
    identity: "XÁC MINH DANH TÍNH",
    library: "THƯ VIỆN CỦA TÔI",
    pages: "Trang",
    information: "THÔNG TIN",
    courses: "Khóa học",
    teachers: "Giảng viên",
    news: "TÌNH BÁO THỊ TRƯỜNG",
    contact: "Liên hệ",
    heroTitle: "KIẾN TẠO NĂNG LỰC",
    heroTitleSecond: "CHO HÀNH TRÌNH TĂNG TRƯỞNG",
    heroButton: "Khám phá hệ sinh thái",
    heroButtonSecond: "Kết nối với HITECH",
    heroCtaText: "Khám phá HITECH TALENT và các chương trình phát triển năng lực",
  },
  en: {
    slogan: "OPTIMIZE PERFORMANCE — CREATE REGENERATIVE VALUE",
    email: "needhelp@kipso.com",
    phone: "444 888 0000",
    login: "Login",
    register: "Register",
    home: "HOME",
    technology: "TECHNOLOGY & DIGITAL INTELLIGENCE",
    technologySolutions: "DIGITAL TECHNOLOGY SOLUTIONS",
    technologyEpc: "EPC DIGITAL TRANSFORMATION",
    technologyAi: "AI & AUTOMATION SOLUTIONS",
    epc: "EPC MANAGEMENT CONSULTING",
    epcPhilosophy: "Operating Philosophy",
    epcAssessment: "Business Assessment",
    epcRoadmap: "Advisory Roadmap",
    talent: "ÁNH DƯƠNG TALENT",
    talentMission: "Self-Reliance Mission",
    talentPlatform: "Solar Capability Platform",
    talentNetwork: "Elite Network",
    portal: "TRANSACTION PORTAL",
    portalAssessment: "Business Assessment Packages",
    portalTalent: "Ánh Dương Talent Programs",
    portalTechnology: "Digital Technology Solutions",
    identity: "IDENTITY VERIFICATION",
    library: "MY LIBRARY",
    pages: "Pages",
    information: "INFORMATION",
    courses: "Courses",
    teachers: "Teachers",
    news: "MARKET ALERTS",
    contact: "Contact",
    heroTitle: "BUILDING CAPABILITY",
    heroTitleSecond: "FOR THE NEXT STAGE OF GROWTH",
    heroButton: "Explore the ecosystem",
    heroButtonSecond: "Connect with HITECH",
    heroCtaText: "Explore HITECH TALENT and our capability-building programs",
  },
};

export const LanguageContext = createContext({
  language: "vi",
  setLanguage: () => {},
  t: translations.vi,
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") return "vi";
    return window.localStorage.getItem("ady-language") || "vi";
  });

  const changeLanguage = (nextLanguage) => {
    setLanguage(nextLanguage);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("ady-language", nextLanguage);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const withLanguage = (Component) => (props) => (
  <LanguageContext.Consumer>
    {(languageProps) => <Component {...props} {...languageProps} />}
  </LanguageContext.Consumer>
);
